import { MultiSelect } from '@/components/ui/multi-select';
import { useInvoiceProjectOptions } from '../queries';
import type { InvoiceProject } from '../types';

/** Multi-select of the projects a client invoice bills. Options are every
 *  project of the client plus company-less ones, private ones included —
 *  finance bills any project (BE ADR-102); projects already linked stay listed
 *  by name even when they predate the company rule. */
export function InvoiceProjectsField({
  company,
  value,
  onChange,
  current,
}: {
  company: string;
  value: string[];
  onChange: (next: string[]) => void;
  /** The invoice's linked projects as saved (edit mode). */
  current: InvoiceProject[];
}) {
  const { data, isPlaceholderData } = useInvoiceProjectOptions(company);
  // Never offer the previous company's projects while the new list loads.
  const listed = data && !isPlaceholderData ? data : [];
  const options = listed.map((p) => ({ value: String(p.id), label: p.name }));
  const seen = new Set(options.map((o) => o.value));
  for (const p of current) {
    if (!seen.has(String(p.id))) options.push({ value: String(p.id), label: p.name });
  }

  return (
    <MultiSelect
      value={value}
      onChange={onChange}
      options={options}
      placeholder="No projects"
      searchPlaceholder="Search projects…"
      emptyText="No projects for this client."
    />
  );
}
